// Manual refresh progress: how long the viewer waits on a run and what the snackbar says.
// Kept dependency-free so it can be unit tested without the viewer's ESM imports.

// The refresh task runs on a Celery worker with a 30 min soft / 35 min hard time limit
// (CELERY_WORKER_SOFT_TIMEOUT_SEC / CELERY_WORKER_HARD_TIMEOUT_SEC). A soft-limit hit marks
// the run failed, which polling picks up; a hard kill leaves it "running" forever. Wait past
// the hard limit (plus queue headroom) so a slow refresh is never abandoned while it can
// still complete (ENG-9262: AI block updates after table changes can take 12-17 min).
export const MANUAL_REFRESH_TIMEOUT_MS = 40 * 60 * 1000;

export const REFRESH_PHASE_STEPS: { minSeconds: number; label: string }[] = [
  { minSeconds: 0, label: "Refreshing…" },
  { minSeconds: 2, label: "Fetching latest data from sheet…" },
  { minSeconds: 6, label: "Analyzing changes…" },
  { minSeconds: 15, label: "Updating dashboard…" },
  { minSeconds: 45, label: "Updating dashboard blocks…" },
  { minSeconds: 3 * 60, label: "Reconnecting charts and tables to changed data…" },
  {
    minSeconds: 10 * 60,
    label: "Still updating blocks. Large changes can take up to 30 minutes…",
  },
];

export const getRefreshPhaseLabel = (secondsElapsed: number): string => {
  let label = REFRESH_PHASE_STEPS[0].label;
  for (const step of REFRESH_PHASE_STEPS) {
    if (secondsElapsed >= step.minSeconds) {
      label = step.label;
    }
  }
  return label;
};
